import { join, sep } from 'path';

import type { DocMetaFieldsUnion } from '@utils/document';
import { LOCALES_ARR } from './i18n';

export const API_FOLDER = 'api-ref';

export const INDEX_FILE_NAME: string = 'index';

export const MD_EXT: string = '.md';

export const MDX_EXT: string = '.mdx';

export const MARKDOWN_EXTENSIONS = [MD_EXT, MDX_EXT];

export const INDEX_MD_FILE_NAME: string = `${INDEX_FILE_NAME}${MD_EXT}`;

export const INDEX_MDX_FILE_NAME: string = `${INDEX_FILE_NAME}${MDX_EXT}`;

export const FOLDER_ROOT_FILES: string[] = [INDEX_MD_FILE_NAME, INDEX_MDX_FILE_NAME];

export const SOURCE_PATH = 'source';

export const LOCALIZATION_PATH = 'localization';

export const SOURCE_API_PATH = join(SOURCE_PATH, API_FOLDER).replaceAll(sep, '/');

export const LOCALIZATION_API_PATHS = LOCALES_ARR.map((locale) =>
  join(LOCALIZATION_PATH, locale, API_FOLDER).replaceAll(sep, '/')
);

export const PARTIALS_FOLDER_NAME = '_partials';

export const NAVIGATION_FOLDER_NAME = '_navigation';
export const GLOSSARY_FOLDER_NAME = '_glossary';

export const DATABASE_NAME = 'eos-docs';

export const PAGE_IDS: {
  [name: string]: string;
} = {
  HOME: 'home',
  DOCUMENTATION: 'documentation',
  GLOSSARY: 'glossary',
  SITEMAP: 'sitemap',
};

export const DOC_META: {
  ID: Extract<'id', DocMetaFieldsUnion>;
  SLUG: Extract<'slug', DocMetaFieldsUnion>;
  NAV_TITLE: Extract<'navTitle', DocMetaFieldsUnion>;
  DESCRIPTION: Extract<'description', DocMetaFieldsUnion>;
  TAGS: Extract<'tags', DocMetaFieldsUnion>;
  INJECT: Extract<'inject', DocMetaFieldsUnion>;
  HERO_COLOR: Extract<'heroColor', DocMetaFieldsUnion>;
  LAYOUT: Extract<'layout', DocMetaFieldsUnion>;
  HERO_LABEL: Extract<'heroLabels', DocMetaFieldsUnion>;
  SEO_TITLE: Extract<'seoTitle', DocMetaFieldsUnion>;
  SEO_DESCRIPTION: Extract<'seoDescription', DocMetaFieldsUnion>;
  SEO_NOFOLLOW: Extract<'seoNoFollow', DocMetaFieldsUnion>;
  SEO_NOINDEX: Extract<'seoNoIndex', DocMetaFieldsUnion>;
  STATUS: Extract<'status', DocMetaFieldsUnion>;
  PROTECTED_GROUPS: Extract<'protectedGroups', DocMetaFieldsUnion>;
} = {
  ID: 'id',
  SLUG: 'slug',
  NAV_TITLE: 'navTitle',
  DESCRIPTION: 'description',
  TAGS: 'tags',
  INJECT: 'inject',
  HERO_COLOR: 'heroColor',
  LAYOUT: 'layout',
  HERO_LABEL: 'heroLabels',
  SEO_TITLE: 'seoTitle',
  SEO_DESCRIPTION: 'seoDescription',
  SEO_NOFOLLOW: 'seoNoFollow',
  SEO_NOINDEX: 'seoNoIndex',
  STATUS: 'status',
  PROTECTED_GROUPS: 'protectedGroups',
};

export const DOC_STATUS_TYPES = {
  DRAFT: 'draft',
};
